"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ensureVersionCompatibility = exports.getDeviceOsSemverWithVariant = exports.normalizeDeviceOsVersion = void 0;
const bSemver = require("balena-semver");
const device_1 = require("./device");
const normalizeDeviceOsVersion = (device) => {
    if (device.os_version != null &&
        device.os_version.length === 0 &&
        (0, device_1.isProvisioned)(device)) {
        device.os_version = 'Resin OS 1.0.0-pre';
    }
};
exports.normalizeDeviceOsVersion = normalizeDeviceOsVersion;
const getDeviceOsSemverWithVariant = ({ os_version, os_variant, }) => {
    if (!os_version) {
        return null;
    }
    const versionInfo = bSemver.parse(os_version);
    if (!versionInfo) {
        return null;
    }
    let { version } = versionInfo;
    const build = versionInfo.build.slice();
    if (os_variant &&
        ![...build, ...versionInfo.prerelease].includes(os_variant)) {
        build.push(os_variant);
    }
    if (build.length > 0) {
        version = `${version}+${build.join('.')}`;
    }
    return version;
};
exports.getDeviceOsSemverWithVariant = getDeviceOsSemverWithVariant;
/**
 * @summary Ensure version compatibility using balena-semver
 * @name ensureVersionCompatibility
 * @private
 * @function
 *
 * @param {String} version - version under check
 * @param {String} minVersion - minimum accepted version
 * @throws {Error} Will reject if the given version is < than the given minimum version
 * @returns {void}
 *
 * @example
 * ensureVersionCompatibility(version, MIN_VERSION)
 * console.log('Is compatible');
 *
 */
const ensureVersionCompatibility = function (version, minVersion, versionType) {
    if (version && bSemver.lt(version, minVersion)) {
        throw new Error(`Incompatible ${versionType} version: ${version} - must be >= ${minVersion}`);
    }
};
exports.ensureVersionCompatibility = ensureVersionCompatibility;
